import { NavLink, RouteObject, useNavigate } from "react-router";

import { Button, ButtonStyle, checkTabIsActive, PageHeading, Tabs } from "@prequel/shared-components";

import WebhookForm from "./WebhookForm";
import WebhookPage, { WebhookDetailsPage, WebhookEditPage } from "./WebhookPage";
import WebhooksTable from "./WebhooksTable";

import Breadcrumbs from "@/components/Breadcrumbs";

const tabs = [
  <NavLink key="Summary" to="/webhooks" className={checkTabIsActive} end>
    Summary
  </NavLink>,
];

const WebhooksListLayout = () => {
  const navigate = useNavigate();

  return (
    <div className="h-full flex-col">
      <div className="max-w-6xl px-7 py-4 pb-16">
        <PageHeading title="Webhooks">
          <Button text="Add Webhook" onClick={() => navigate("/webhooks/new")} type={ButtonStyle.SECONDARY} />
        </PageHeading>
        <Tabs tabs={tabs} />
        <WebhooksTable />
      </div>
    </div>
  );
};

const WebhookFormLayout = () => {
  const navigate = useNavigate();

  return (
    <div className="h-full flex-col">
      <div className="max-w-2xl px-7 py-4">
        <PageHeading title="Add Webhook" onGoBack={() => navigate("/webhooks")} breadcrumbs={<Breadcrumbs />} />
        <WebhookForm initialWebhook={undefined} />
      </div>
    </div>
  );
};

export const webhooksRoutes: RouteObject = {
  path: "webhooks",
  handle: {
    breadcrumb: () => ({ label: "Webhooks" }),
  },
  children: [
    {
      index: true,
      element: <WebhooksListLayout />,
    },
    {
      path: "new",
      handle: {
        breadcrumb: () => ({ label: "Add Webhook" }),
      },
      element: <WebhookFormLayout />,
    },
    {
      path: ":webhookID",
      handle: {
        breadcrumb: () => ({
          label: "Webhook Details",
          dynamic: true,
        }),
      },
      element: <WebhookPage />,
      children: [
        {
          index: true,
          element: <WebhookDetailsPage />,
        },
        {
          path: "edit",
          handle: {
            breadcrumb: () => ({
              label: "Edit Webhook",
            }),
          },
          element: <WebhookEditPage />,
        },
      ],
    },
  ],
};
